module.exports = __webpack_public_path__ + "img/warn.4ac02e5.svg";